import type { RouteRecordRaw } from 'vue-router';
import layout from '@/layout/index.vue';
import mainBox from '@/layout/components/mainBox.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'layout',
        component: layout,
        redirect: {name: 'dashboard'},
        children: [
            {
                path: 'home',
                name: 'home',
                component: mainBox,
                meta: { title: '数据分析', icon: 'TrendCharts' },
                children: [
                    {
                        path: 'dashboard',
                        name: 'dashboard',
                        component: () => import('@/views/home/index.vue'),
                        meta: {
                            icon: 'Histogram',
                            title: '查询分析',
                        },
                    },
                    // {
                    //     path: 'dialogue',
                    //     name: 'dialogue',
                    //     component: () => import('@/views/home/dialogue.vue'),
                    //     meta: {
                    //         icon: 'ChatLineRound',
                    //         title: '对话日志',
                    //     },
                    // },
                ],
            },
            {
                path: 'channel',
                name: 'channel',
                component: mainBox,
                meta: { title: '渠道管理', icon: 'Connection' },
                children: [
                    {
                        path: 'channelList',
                        name: 'channelList',
                        component: () => import('@/views/channel/index.vue'),
                        meta: { title: '渠道列表', icon: 'List' },
                    },
                    {
                        path: 'channelConfig',
                        name: 'channelConfig',
                        component: () => import('@/views/channel/config.vue'),
                        meta: { title: '特殊附加配置', icon: 'Setting' },
                    },
                ],
            },
            {
                path: 'info',
                name: 'info',
                component: mainBox,
                meta: { title: '知识管理', icon: 'Collection' },
                children: [
                    {
                        path: 'infoBase',
                        name: 'infoBase',
                        component: () => import('@/views/info/index.vue'),
                        meta: { title: '基础信息知识库', icon: 'Document' },
                    },
                    {
                        path: 'infoDownload',
                        name: 'infoDownload',
                        component: () => import('@/views/info/download.vue'),
                        meta: { title: '基础文件下载库', icon: 'Download' },
                    },
                    {
                        path: 'infoConfig',
                        name: 'infoConfig',
                        component: () => import('@/views/info/config.vue'),
                        meta: { title: '附加费货品配置', icon: 'Coin' },
                    },
                ],
            },
            {
                path: 'interface',
                name: 'interface',
                component: mainBox,
                meta: { title: '接口管理', icon: 'Cpu' },
                children: [
                    {
                        path: 'interfaceConfig',
                        name: 'interfaceConfig',
                        component: () => import('@/views/interface/index.vue'),
                        meta: { title: '接口配置', icon: 'Setting' },
                    },
                ],
            },
            {
                path: 'wx',
                name: 'wx',
                component: mainBox,
                meta: { title: '微信管理', icon: 'ChatLineRound' },
                children: [
                    
                    {
                        path: 'group',
                        name: 'group',
                        component: () => import('@/views/wechat/group.vue'),
                        meta: { title: '微信群聊', icon: 'ChatDotRound' },
                    },
                    {
                        path: 'user',
                        name: 'wxuser',
                        component: () => import('@/views/wechat/wxUser.vue'),
                        meta: { title: '微信联系人', icon: 'UserFilled' },
                    },
                    {
                        path: 'logs',
                        name: 'logs',
                        component: () => import('@/views/wechat/msgLog.vue'),
                        meta: { title: '群发记录', icon: 'Clock' },
                    },
                    {
                        path: 'robot',
                        name: 'robot',
                        component: () => import('@/views/wechat/robot.vue'),
                        meta: { title: '机器人设置', icon: 'Promotion' },
                    },
                    {
                        path: 'pullGroup',
                        name: 'pullGroup',
                        component: () => import('@/views/wechat/pullGroup.vue'),
                        meta: { title: '自动拉群设置', icon: 'Collection' },
                    },
                ],
            },
            {
                path: 'system',
                name: 'system',
                component: mainBox,
                meta: { title: '系统管理', icon: 'Setting' },
                children: [
                    {
                        path: 'employee',
                        name: 'employee',
                        component: () => import('@/views/system/employee.vue'),
                        meta: { title: '员工账号', icon: 'User' },
                    },
                    {
                        path: 'version',
                        name: 'version',
                        component: () => import('@/views/system/version.vue'),
                        meta: { title: '版本管理', icon: 'Collection' },
                    },
                    {
                        path: 'finance',
                        name: 'finance',
                        component: () => import('@/views/system/finance.vue'),
                        meta: { title: '财务管理', icon: 'Coin' },
                    },
                    {
                        path: 'company',
                        name: 'company',
                        component: () => import('@/views/system/company.vue'),
                        meta: { title: '公司管理', icon: 'OfficeBuilding' },
                    },
                ],
            },
        ],
    },
    {
        path: '/webchat',
        name: 'webchat',
        component: mainBox,
        redirect: {name: 'webchatPage'},
        children: [
            {
                path: ':id',
                name: 'webchatPage',
                component: () => import('@/views/webchat/index.vue'),
            },
            {
                path: 'preview/:id',
                name: 'preview',
                component: () => import('@/views/webchat/preview.vue'),
            },
        ],
    },
    {
        path: '/login',
        name: 'login',
        component: mainBox,
        redirect: {name: 'loginPage'},
        children: [
            {
                path: '',
                name: 'loginPage',
                component: () => import('@/views/login/index.vue'),
            },
            {
                path: 'success',
                name: 'loginSuccess',
                component: () => import('@/views/login/success.vue'),
            },
        ],
    },

    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register/index.vue'),
    },
    {
        path: '/forget',
        name: 'forget',
        component: () => import('@/views/login/forget.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/404.vue'),
        meta: {
            title: '页面未找到',
        },
    },
];

export default routes;
